import { render, staticRenderFns } from "./MobileAdBanner.vue?vue&type=template&id=15f8291c&scoped=true"
import script from "./MobileAdBanner.vue?vue&type=script&lang=js"
export * from "./MobileAdBanner.vue?vue&type=script&lang=js"
import style0 from "./MobileAdBanner.vue?vue&type=style&index=0&id=15f8291c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f8291c",
  null
  
)

export default component.exports